import { render, staticRenderFns } from "./TipsTable.vue?vue&type=template&id=5e56a714"
import script from "./TipsTable.vue?vue&type=script&lang=js"
export * from "./TipsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports